// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testSessionId } from './TestSession';
import { fileStorageId } from './FileStorage';
import { testSessionFileKindEnum } from './TestSessionFileKindEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const testSessionFileId = (z.number());
export const testSessionFile = z.object({
    id: testSessionFileId,
    test_session_id: testSessionId,
    file_storage_id: fileStorageId,
    kind: testSessionFileKindEnum,
    report_version: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    caption: z.string().nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const testSessionFileInitializer = z.object({
    id: testSessionFileId.optional(),
    test_session_id: testSessionId,
    file_storage_id: fileStorageId,
    kind: testSessionFileKindEnum,
    report_version: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    caption: z.string().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const testSessionFileMutator = z.object({
    id: testSessionFileId.optional(),
    test_session_id: testSessionId.optional(),
    file_storage_id: fileStorageId.optional(),
    kind: testSessionFileKindEnum.optional(),
    report_version: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    caption: z.string().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=TestSessionFile.js.map